import { combineReducers } from "redux";

// ::::::::::::: vivn user :::::::::::::::::::://
import userAuthReducer from "./user/auth/user_auth.reducer";
import loginReducer from "./user/login/login.reducer";
// ::::::::::::: vivn base :::::::::::::::::::://
import bailiffAuthReducer from "./bailiff/auth/bailiff_auth.reducer";
import orderBailiffReducer from "./bailiff/payment/order/order_bailiff.reducer";
import navReducer from "./bailiff/nav/nav.reducer";
import defaultSupporterReducer from "./user/(default)/supporter/default_supporter.reducer";
import paymentWithdrawReducer from "./bailiff/payment/withdraw/payment_withdraw.reducer";
import financeLifeReducer from "./bailiff/finance/life/life.reducer";
import financeManagerReducer from "./bailiff/finance/manager/finance_manager.reducer";
import defaultWalletReducer from "./bailiff/default/wallet/default_wallet.reducer";
import defaultBankReducer from "./bailiff/default/bank/default_bank.reducer";
import settingWithdrawReducer from "./bailiff/default/withdraw/setting_withdraw.reducer";

const rootReducer = combineReducers({
  //auth
  userAuthReducer,
  bailiffAuthReducer,
  loginReducer,
  //supporter
  defaultSupporterReducer,
  defaultWalletReducer,
  defaultBankReducer,
  settingWithdrawReducer,

  //finance
  financeLifeReducer,
  financeManagerReducer,

  //payment
  paymentWithdrawReducer,

  //order
  orderBailiffReducer,
  //nav
  navReducer,
});

export default rootReducer;
